import React from 'react';

export default (props) => {
    return (
        <div className="dentist-info">
            <div className="dentist-info__block">
                <h3>Personal information</h3>
                <p>
                    <span>First Name:</span>
                    <span>{props.data.first_name}</span>
                </p>
                <p>
                    <span>Last Name:</span>
                    <span>{props.data.last_name}</span>
                </p>
                <p>
                    <span>Username:</span>
                    <span>{props.data.username}</span>
                </p>
                <p>
                    <span>Email:</span>
                    <span>{props.data.email}</span>
                </p>
                <p>
                    <span>Status:</span>
                    <span>{props.data.status}</span>
                </p>
            </div>
            <div className="dentist-info__block">
                <h3>Bussiness information</h3>
                <p>
                    <span>Business Name:</span>
                    <span>{props.data.business_name}</span>
                </p>
                <p>
                    <span>Business Email:</span>
                    <span>{props.data.business_email}</span>
                </p>
                <p>
                    <span>Business Phone:</span>
                    <span>{props.data.business_phone}</span>
                </p>
                <p>
                    <span>Country:</span>
                    <span>{props.data.country}</span>
                </p>
                <p>
                    <span>City:</span>
                    <span>{props.data.city}</span>
                </p>
                <p>
                    <span>Street Address:</span>
                    <span>{props.data.street_address}</span>
                </p>
                <p>
                    <span>Zip Code:</span>
                    <span>{props.data.zip_code}</span>
                </p>
                <p>
                    <span>License:</span>
                    <span>{props.data.license}</span>
                </p>
                {
                    props.data.website ?
                        <p>
                            <span>Web Site:</span>
                            <span>{props.data.website}</span>
                        </p> : ''
                }
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/Dentists/DentistInfo.js